export const LoginConstant = {
  LOGIN_API: "vendor/login",
  LOGIN_DATA: "LOGIN_DATA",
  LOGOUT_SAGA: "LOGOUT_SAGA",
};
